export function resolveTaskAssigneeOrgId(task, projectsList = []) {
  if (!task) return null;

  const pid = task.project_id;
  let project = task.project;
  if (pid && project && String(project.project_id) !== String(pid)) {
    project = null;
  }
  if (!project && pid && projectsList.length) {
    project = projectsList.find((p) => String(p.project_id) === String(pid));
  }

  if (project) {
    const companyOrg = project.company?.org_id;
    if (companyOrg != null && companyOrg !== "") {
      return companyOrg;
    }
    if (project.org_id != null && project.org_id !== "") {
      return project.org_id;
    }
  }

  return task.org_id ?? null;
}
